export const Line = ({ color = "black", height = "2px", width = "80%", boxShadow = "0px 0px 8px 1px darkgrey" }) => {
  return (
    <hr
      className="mx-auto m-0"
      style={{
        color: color,
        backgroundColor: color,
        height: height,
        width: width,
        opacity: 1,
        boxShadow: boxShadow,
      }}
    />
  );
};
